<template>
  <div class="content">
    <v-col cols="8">
      <p class="modalXMargin titleModal">
        {{ $t('forms.labels.automaticSentences') }}
      </p>
      <VSelect
        v-model="selectedCategory"
        outlined
        itemValue="id"
        :items="categories"
        :label="$t('forms.labels.category')"
        :loading="loadingCategories"
      />
      <VAutocomplete
        v-model="selectedSentence"
        :disabled="!selectedCategory"
        outlined
        :items="displayedSentences"
        :label="$t('forms.labels.automaticSentences')"
        :loading="loadingSentences"
        @change="onChangeSentence"
      />
      <p class="modalXMargin titleModal">
        {{ $t('forms.labels.comment') }}
      </p>
      <VTextarea
        v-model="noteForm.note"
        :disabled="!isAnalysis"
        outlined
        :value="sentence"
        :label="$t('forms.labels.comment')"
        :rules="{ required: !forAnalysis ,max: 2000, min: 1 }"
        @change="updateData"
      />
    </v-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';

export default {
    components: {
        VAutocomplete,
        VSelect,
        VTextarea,
    },
    props: {
        measure: {
            type: Object,
            default: () => {},
        },
        isAnalysis: {
            type: Boolean,
            default: false,
        },
        lang: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            // Categories
            categories: [],
            loadingCategories: true,
            loadingSentences: false,
            selectedCategory: null,
            // Selected Sentences
            sentence: null,
            sentences: [],
            selectedSentence: '',
            // Texte
            noteForm: {
                note: '',
            },
        };
    },
    computed: {
        ...mapGetters([
            'userLang', 'site', 'teamMainLang', 'labWorkOrder', 'siteLang',
        ]),
        displayedSentences() {
            if (this.sentences) {
                return this.sentences.map(s => ({ id: s.id, name: s.title[this.userLang] || s.title[this.teamMainLang] }));
            }
            return [];
        },
        forAnalysis() {
            return !!this.isAnalysis;
        },

    },
    watch: {
        selectedCategory: {
            handler() {
                this.getSentences(this.selectedCategory);
            },
        },
    },
    async created() {
        await this.getCategories();
        this.getNote();
    },
    methods: {
        async getCategories() {
            const { data } = await this.$rq.getSentenceCategories();
            this.categories = data.categories.map(cat => ({ ...cat, name: cat.name[this.userLang] || cat.name[this.teamMainLang] }));
            this.loadingCategories = false;
        },
        async getSentences(categoryId) {
            this.loadingSentences = true;
            const { data } = await this.$rq.getAutomaticSentences({ categoryId });
            this.sentences = data.sentences || [];
            this.loadingSentences = false;
        },
        async onChangeCategory(value) {
            await this.getSentences(value);
        },
        onChangeSentence(value) {
            const found = this.sentences.find(({ id }) => id === value);
            if (found) {
                this.selectedSentence = value; // recupération de l'id de la phrase
                const lang = this.lang || this.site?.lang || this.labWorkOrder?.site?.lang || this.siteLang;
                this.sentence = found.sentence[lang]; // Récupération de la phrase
                if (this.noteForm && !this.noteForm.note) {
                    this.noteForm.note = '';
                }
                this.noteForm.note += this.sentence;
                this.sendDatas();
            }
        },
        updateData() {
            this.selectedSentence = '';
            this.sentence = '';
            this.selectedCategory = '';
            this.sendDatas();
        },

        sendDatas() {
            let preparePayload;
            if (this.sentence !== '') {
                preparePayload = {
                    note: this.noteForm.note,
                    sentence: this.selectedSentence,
                    category: this.selectedCategory,
                };
            } else {
                preparePayload = {
                    note: this.noteForm.note,
                };
            }
            this.$emit('sendData', preparePayload);
        },

        getNote() {
            if (this.measure) {
                this.noteForm.note = this.measure.note;
                this.selectedCategory = this.measure.category;
                this.selectedSentence = this.measure.sentence;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .content {
        display: flex;
        flex-direction: column;
        align-items: center
    }
    .modalXMargin {
        margin-left: 0;
        margin-right: 0;
    }
</style>
